<container-tag>
    <register-modal modal-id="register-modal"></register-modal>
    <script>
        import di from 'dependeny-injection'
        import registerModal from "@tags/modal/register-modal.riot";

        export default {
            components: {
                "register-modal": registerModal,
            },
            openModal(){
                window.$(this.$('#register-modal')).fadeIn(100);
            },
            onMounted() {
                di.route.mount('register', ()=> {
                    this.openModal();
                });
                di.route.start(true)
            }
        }
    </script>

</container-tag>